export default function dataReducer(state = {
    dashboard_info: {},
    vehicles: [],
    vehicle_db: {},
    profile_db: {},
    bookings_db: {},
    current_survey: {},
    media: [],
    return_release_bookings: [],
    return_release_bookings_dictionary: {}
}, action) {
    switch(action.type) {
        case "SET_DASHBOARD" :{
            return state = {
                ...state,
                dashboard_info: action.payload
            }
        }

        case "SET_VEHICLES" :{
            return state = {
                ...state,
                vehicles: action.payload
            }
        }

        case "SET_VEHICLE_DB" :{
            return state = {
                ...state,
                vehicle_db: action.payload
            }
        }

        case "SET_PROFILE_DB" :{
            return state = {
                ...state,
                profile_db: action.payload
            }
        }

        case "SET_BOOKING_DB" :{
            return state = {
                ...state,
                bookings_db: action.payload
            }
        }

        case "SET_SURVEY" :{
            return state = {
                ...state,
                current_survey: action.payload
            }
        }

        case "SET_return_release" :{
            return state = {
                ...state,
                return_release_bookings: action.payload.return_release_bookings,
                return_release_bookings_dictionary: action.payload.return_release_bookings_dictionary
            }
        }

        default: {

        }
    }

    return state;
}